import "./App.scss";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import CustomRouter from "./router";
import { Fragment, useCallback, useContext, useEffect } from "react";
import {
    AuthContextProvider,
    InnerWidthContextProvider,
    LayoutBarContextProvider,
    SignUpContextProvider,
    CustomModalContextProvider,
    PersonalDataContextProvider,
    InitDataContext,
    NavBarContextProvider,
    LoaderContextProvider,
} from "./contexts";
import {
    getContactProfils,
    getEstablishmentGroups,
    getEstablishmentTypes,
} from "./services";
import { Session } from "./types";
import {
    establishementKey,
    sessionStorageKey,
    contactsStorageKey,
} from "./consts";
import { useLocalStorage } from "./hooks";

function App() {
    const { setValue, storedValue } =
        useLocalStorage<Session>(sessionStorageKey);

    const { initDataContext } = useContext(InitDataContext);

    const initData = useCallback(async () => {
        const establishmentTypesRes = await getEstablishmentTypes();
        const establishmentGroupsRes = await getEstablishmentGroups();
        const contactProfilsRes = await getContactProfils();

        if (
            !establishmentGroupsRes.detail &&
            !establishmentTypesRes.detail &&
            !contactProfilsRes.detail
        ) {
            const dataInit = {
                [establishementKey]: {
                    establishmentTypes: establishmentTypesRes,
                    establishmentGroups: establishmentGroupsRes,
                },
                [contactsStorageKey]: {
                    profils: contactProfilsRes,
                },
            };

            initDataContext(dataInit);
            await setValue({
                ...storedValue,
                ...dataInit,
            });
        }
    }, []);

    useEffect(() => {
        const _initData = async () => {
            await initData();
        };

        _initData();
    }, [initData]);

    return (
        <ThemeProvider theme={theme}>
            <LayoutBarContextProvider>
                <SignUpContextProvider>
                    <LoaderContextProvider>
                        <NavBarContextProvider>
                            <AuthContextProvider>
                                <InnerWidthContextProvider displayName="InnerWidthContextProvider">
                                    <CustomModalContextProvider displayName="InnerWidthContextProvider">
                                        <PersonalDataContextProvider displayName="PersonalDataContextProvider">
                                            <Fragment>
                                                <CustomRouter />
                                            </Fragment>
                                        </PersonalDataContextProvider>
                                    </CustomModalContextProvider>
                                </InnerWidthContextProvider>
                            </AuthContextProvider>
                        </NavBarContextProvider>
                    </LoaderContextProvider>
                </SignUpContextProvider>
            </LayoutBarContextProvider>
        </ThemeProvider>
    );
}

export default App;
